module.exports = __webpack_public_path__ + "static/img/logo.75635c8f.svg";